import { render, staticRenderFns } from "./create_issue_form.vue?vue&type=template&id=1e76d66a&"
import script from "./create_issue_form.vue?vue&type=script&lang=js&"
export * from "./create_issue_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports